<template>
  <section test_id="written-content-section">
    <Card>
      <div class="tw-flex tw-items-center tw-justify-between">
        <h2 class="tw-heading-2">My best written content</h2>
        <EditWrittenContent
          v-if="isEditModeEnabled"
          :links="links"
          test_id="written-content-edit"
        />
      </div>
      <div class="tw-mt-4">
        <div v-for="(link, index) in links" :key="index">
          <a
            class="tw-link tw-my-1 tw-inline-block tw-break-all tw-py-1 md:tw-my-0 md:tw-py-0"
            :href="link.url"
            target="_blank"
          >
            {{ link.url }}
          </a>
        </div>
      </div>
    </Card>
  </section>
</template>

<script setup>
import Card from '@/shared/components/Card.vue'
import EditWrittenContent from './EditWrittenContent.vue'
import { useEditProfileModeInjector } from '@/shared/composables/edit-profile-mode/useEditProfileModeInjector.js'

defineProps({
  links: {
    type: Array,
    required: true,
  },
})

const { isEditModeEnabled } = useEditProfileModeInjector()
</script>
